import React, { Component } from "react";
import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    hangefire: state.hangfire,
  };
}

class SapPoDataContainer extends Component {
  state = {
    isHide: true,
  };
  id = null;
  componentDidMount() {
    this.setState({
      isHide: !this.props.hangefire.isWorking,
    });
  }

  componentWillUnmount() {
    if (this.id !== null) clearTimeout(this.id);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.hangefire !== this.props.hangefire) {
      if (!this.props.hangefire.isWorking && !this.state.isHide) {
        this.id = setTimeout(() => {
          this.setState({
            isHide: true,
          });
          this.id = null;
        }, 5000);
      } else {
        if (this.id !== null) clearTimeout(this.id);
        this.setState({
          isHide: !this.props.hangefire.isWorking,
        });
      }
    }
  }

  render() {
    let { count, items } = this.props.hangefire;
    items = items || [];
    let last = items[items.length - 1] || { status: "" };
    return (
      <div
        className="sap-po-con"
        style={{ display: this.state.isHide ? "none" : "block" }}
      >
        <span className="sap-po-min" style={{ cursor: "pointer" }}>
          _
        </span>
        <p className="text-center">Sap Po Working</p>
        <p>Output Files: {count || 0}</p>
        <p>
          Reading File: {items.length || 0} of {count || 0} (
          {(!count ? 0 : (items.length / count) * 100).toFixed(0)}%)
        </p>
        <p>File Name: {last.FileName}</p>
        <p>
          Read Result:{" "}
          {last.Status === "Fail" ? (
            <span className="label label-danger">Fail</span>
          ) : (
            <span className="label label-success">Success</span>
          )}
        </p>
        {last.Status === "Fail" ? (
          <p>Error: {last.Error}</p>
        ) : (
          <p>Po No: {last.Error}</p>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(SapPoDataContainer);
